import { Miembro } from '../lib/supabase';

/**
 * Estado de registro de un miembro — el funnel que se muestra en la UI.
 *
 * Solo `prerregistrado` y `registrado` están persistidos en `estado_ficha`.
 * `por_solicitar` / `solicitado` / `link_vencido` son lecturas derivadas del
 * estado `sin_completar` según el token de invitación, calculadas aquí (front)
 * y en los RPCs (back) — la columna `estado_ficha` no las almacena.
 */
export type EstadoRegistro =
  | 'por_solicitar'
  | 'solicitado'
  | 'link_vencido'
  | 'prerregistrado'
  | 'registrado';

type FichaFields = Pick<
  Miembro,
  'estado_ficha' | 'invitation_token' | 'invitation_expires_at' | 'invitation_used_at'
>;

export function deriveEstadoRegistro(m: FichaFields): EstadoRegistro {
  if (m.estado_ficha === 'prerregistrado') return 'prerregistrado';
  if (m.estado_ficha === 'registrado') return 'registrado';
  // sin_completar (o default): se desglosa según el token
  if (!m.invitation_token) return 'por_solicitar';
  if (m.invitation_used_at) return 'solicitado';
  const expired =
    !!m.invitation_expires_at && new Date(m.invitation_expires_at).getTime() < Date.now();
  return expired ? 'link_vencido' : 'solicitado';
}

export const ESTADO_REGISTRO_LABEL: Record<EstadoRegistro, string> = {
  por_solicitar: 'Por solicitar',
  solicitado: 'Solicitado',
  link_vencido: 'Link vencido',
  prerregistrado: 'Prerregistrado',
  registrado: 'Registrado',
};

export type BadgeVariant = 'default' | 'info' | 'danger' | 'prerregistrado' | 'success';

export const ESTADO_REGISTRO_BADGE_VARIANT: Record<EstadoRegistro, BadgeVariant> = {
  por_solicitar: 'default',
  solicitado: 'info',
  link_vencido: 'danger',
  prerregistrado: 'prerregistrado',
  registrado: 'success',
};
